module.exports = __webpack_public_path__ + "img/img25.7952ecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img25.png
// module id = 266
// module chunks = 0